import styles from "./Loading.module.scss";

const Loading = () => {
  return (
    <div className={styles.spinner_component}>
      <div className={styles.custom_spinner}>
        <div className={styles.inner_circle}></div>
        <div className={styles.rotating_border}></div>
      </div>
    </div>
  );
};

export default Loading;
